module.exports = __webpack_public_path__ + "img/ecardactive.205ab4c9.png";